var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"about"},[_c('h1',[_vm._v("Deductive Care")]),_c('p',[_vm._v("Deductive Care is a healthcare management application for healthcare providers.")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }